import { News } from '@/types/community/news';

export const newsItems: News[] = [
  {
    id: 'NEWS001',
    title: 'Renovação da Piscina da Comunidade',
    description: 'A piscina da comunidade passará por renovação de 15 de março a 15 de abril. Durante este período, a piscina estará fechada para manutenção e melhorias.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-01T10:00:00'),
    expiryDate: new Date('2024-04-15T23:59:59'),
    liked: {
      count: 12,
      users: [
        { id: 'RES001', name: 'João Silva' },
        { id: 'RES002', name: 'Maria Silva' }
      ]
    },
    comments: [
      {
        content: 'Ótima notícia! A piscina realmente precisa de renovação.',
        author: { id: 'RES001', name: 'João Silva', type: 'resident' },
        createdAt: new Date('2024-03-01T11:00:00')
      }
    ],
    photos: [
      {
        id: 'PHOTO001',
        name: 'pool_renovation.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS001/pool_renovation.jpg',
        url: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-01T10:00:00')
      }
    ],
    attachments: [
      {
        id: 'ATT001',
        name: 'plano_renovacao_piscina.pdf',
        type: 'application/pdf',
        size: 2048,
        path: '/documents/news/NEWS001/pool_renovation_plan.pdf',
        url: 'https://example.com/docs/pool_renovation.pdf',
        uploadedAt: new Date('2024-03-01T10:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS002',
    title: 'Nova Academia Abrindo',
    description: 'Estamos animados em anunciar a abertura da nossa nova academia de última geração. A instalação inclui equipamentos modernos e estará aberta 24/7.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-05T14:00:00'),
    expiryDate: new Date('2024-04-05T23:59:59'),
    liked: {
      count: 8,
      users: [
        { id: 'RES003', name: 'Miguel Johnson' },
        { id: 'RES004', name: 'Sara Wilson' }
      ]
    },
    comments: [],
    photos: [
      {
        id: 'PHOTO002',
        name: 'fitness_center.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS002/fitness_center.jpg',
        url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-05T14:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS003',
    title: 'Reunião Mensal da Comunidade',
    description: 'Junte-se a nós para nossa reunião mensal da comunidade em 20 de março às 19h na casa do clube. Discutiremos projetos futuros e abordaremos as preocupações dos residentes.',
    category: 'event',
    status: 'published',
    author: {
      id: 'EMP002',
      name: 'Gerente Assistente',
      type: 'employee',
      profilePicture: {
        id: 'PROF002',
        name: 'assistant_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP002/assistant_manager.jpg',
        url: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-10T09:00:00'),
    expiryDate: new Date('2024-03-21T23:59:59'),
    liked: {
      count: 15,
      users: [
        { id: 'RES005', name: 'David Brown' },
        { id: 'RES006', name: 'Amanda Martinez' }
      ]
    },
    comments: [
      {
        content: 'Vou estar lá! Temos algumas questões importantes para discutir.',
        author: { id: 'RES005', name: 'David Brown', type: 'resident' },
        createdAt: new Date('2024-03-10T10:00:00')
      }
    ],
    photos: [
      {
        id: 'PHOTO003',
        name: 'community_meeting.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS003/community_meeting.jpg',
        url: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-10T09:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS004',
    title: 'Atualização da Política de Estacionamento',
    description: 'As políticas de estacionamento atualizadas entrarão em vigor a partir de 1º de abril. Por favor, revise as novas diretrizes e garanta conformidade.',
    category: 'guideline',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-12T11:00:00'),
    expiryDate: new Date('2024-04-12T23:59:59'),
    photos: [
      {
        id: 'PHOTO004',
        name: 'parking_policy.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS004/parking_policy.jpg',
        url: 'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-12T11:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS005',
    title: 'Manutenção Programada do Elevador',
    description: 'Os elevadores do Bloco A passarão por manutenção programada em 25 de março das 9h às 17h. Pedimos desculpas pelo inconveniente.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP003',
      name: 'Técnico de Manutenção',
      type: 'employee',
      profilePicture: {
        id: 'PROF003',
        name: 'maintenance_tech.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP003/maintenance_tech.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-15T08:00:00'),
    expiryDate: new Date('2024-03-26T23:59:59'),
    photos: [
      {
        id: 'PHOTO005',
        name: 'elevator_maintenance.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS005/elevator_maintenance.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-15T08:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS006',
    title: 'Novo Sistema de Segurança',
    description: 'Implementamos um novo sistema de segurança com câmeras de alta definição e controle de acesso biométrico. A segurança da comunidade foi significativamente aprimorada.',
    category: 'alert',
    status: 'published',
    author: {
      id: 'EMP004',
      name: 'Chefe de Segurança',
      type: 'employee',
      profilePicture: {
        id: 'PROF004',
        name: 'security_chief.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP004/security_chief.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-18T16:00:00'),
    expiryDate: new Date('2024-04-18T23:59:59'),
    photos: [
      {
        id: 'PHOTO006',
        name: 'security_system.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS006/security_system.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-18T16:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS007',
    title: 'Festival da Primavera da Comunidade',
    description: 'Junte-se a nós para celebrar a chegada da primavera com nosso festival anual! Haverá música ao vivo, jogos para crianças e deliciosas opções de comida.',
    category: 'event',
    status: 'published',
    author: {
      id: 'EMP002',
      name: 'Gerente Assistente',
      type: 'employee',
      profilePicture: {
        id: 'PROF002',
        name: 'assistant_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP002/assistant_manager.jpg',
        url: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-20T12:00:00'),
    expiryDate: new Date('2024-04-20T23:59:59'),
    photos: [
      {
        id: 'PHOTO007',
        name: 'spring_festival.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS007/spring_festival.jpg',
        url: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-20T12:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS008',
    title: 'Atualização da Política de Animais de Estimação',
    description: 'Revisamos nossa política de animais de estimação para melhor acomodar os residentes com animais de serviço. As novas diretrizes estão disponíveis no portal.',
    category: 'guideline',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-22T14:00:00'),
    expiryDate: new Date('2024-04-22T23:59:59'),
    photos: [
      {
        id: 'PHOTO008',
        name: 'pet_policy.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS008/pet_policy.jpg',
        url: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-22T14:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS009',
    title: 'Melhorias na Área de Lazer',
    description: 'Estamos adicionando novos equipamentos de playground e uma área de piquenique na seção norte da propriedade. As obras devem ser concluídas até o final de abril.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP005',
      name: 'Coordenador de Projetos',
      type: 'employee',
      profilePicture: {
        id: 'PROF005',
        name: 'project_coordinator.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP005/project_coordinator.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-25T09:00:00'),
    expiryDate: new Date('2024-04-25T23:59:59'),
    photos: [
      {
        id: 'PHOTO009',
        name: 'leisure_area.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS009/leisure_area.jpg',
        url: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-25T09:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS010',
    title: 'Programa de Reciclagem da Comunidade',
    description: 'Lançamos um novo programa de reciclagem para reduzir o desperdício e promover a sustentabilidade. Recipientes de reciclagem foram adicionados em todas as áreas comuns.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP006',
      name: 'Coordenador de Sustentabilidade',
      type: 'employee',
      profilePicture: {
        id: 'PROF006',
        name: 'sustainability_coordinator.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP006/sustainability_coordinator.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-28T11:00:00'),
    expiryDate: new Date('2024-04-28T23:59:59'),
    photos: [
      {
        id: 'PHOTO010',
        name: 'recycling_program.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS010/recycling_program.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-28T11:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 